import { LEGAL_BASE_PATH } from './index'
import {
  STANDARD_ORGANIZATION_SCHEMA,
  LOCAL_BUSINESS_SCHEMA,
  getRatingData,
} from './schemaConstants'
import {
  trustMarkerEntryRatingNumber,
  trustMarkerEntryTotalReviewNumber,
  trustPilotEntryFromMarkerList,
} from '../trustMarkerEntryFields'

// Export the new centralized schema constants
export * from './schemaConstants'

// Note: All schema constants and utility functions are exported via "export * from './schemaConstants'" above

export const ldVariationEnums = {
  control: {
    name: 'Control',
    label: 'control',
  },
  'variation-a': {
    name: 'Variation A',
    label: 'variation_a',
  },
  'variation-b': {
    name: 'Variation B',
    label: 'variation_b',
  },
}

// Legacy commonSchemaData - now uses centralized STANDARD_ORGANIZATION_SCHEMA
// @deprecated Use STANDARD_ORGANIZATION_SCHEMA directly from schemaConstants.js
export const commonSchemaData = STANDARD_ORGANIZATION_SCHEMA

// Legacy localBusinessSchemaData - now uses centralized LOCAL_BUSINESS_SCHEMA
// @deprecated Use LOCAL_BUSINESS_SCHEMA directly from schemaConstants.js
export const localBusinessSchemaData = LOCAL_BUSINESS_SCHEMA

export const getTrustPilotInfo = (trustMarkersResponse, trustMarker) => {
  const trustMarkerInfo = trustMarkersResponse.find(
    (item) => item.id?.toLowerCase() === 'home-variant-8'
  )
  const trustPilot = trustPilotEntryFromMarkerList(trustMarkerInfo?.trustMarker)
  if (trustPilot) {
    const ratingNum = trustMarkerEntryRatingNumber(trustPilot)
    const totalNum = trustMarkerEntryTotalReviewNumber(trustPilot)
    if (Number.isFinite(ratingNum) && Number.isFinite(totalNum)) {
      // Use centralized rating data structure
      trustMarker = getRatingData({
        ratingValue: ratingNum,
        ratingCount: totalNum,
        reviewCount: totalNum,
      })
    }
  }

  return trustMarker
}

export const processDisclosureUrl = `${LEGAL_BASE_PATH}/privacy/process-disclosure.js`
export const loadDisclosuresUrl = `${LEGAL_BASE_PATH}/privacy/load-disclosure.json`
